import { createSelector } from 'reselect'
import { groupBy } from 'lodash'

import { getPopularDestinations as getPopularDestinationsFromLanding } from 'selectors/cms/landings'

import { mapPopularDestination } from 'api-data-io/cms/popularDestination'

const getPopularDestinationsState = state => state.popularDestinations

const getPopularDestinationsData = createSelector([getPopularDestinationsState], state =>
  state && state.data && state.data[0] ? state.data[0] : null
)

export const getPopularDestinations = createSelector([getPopularDestinationsData], data =>
  data && data.destinationsReference
    ? data && data.destinationsReference.map(item => mapPopularDestination(item))
    : null
)

export const isFetchingPopularDestinations = createSelector([getPopularDestinationsState], state =>
  state ? state.isFetching : false
)

export const getPopularDestinationsError = createSelector([getPopularDestinationsState], state =>
  state ? state.error : null
)

export const selectPopularDestinationsFromSource = createSelector(
  [getPopularDestinations, getPopularDestinationsFromLanding],
  (pdHome, pdLanding) => (pdHome || pdLanding ? groupBy(pdHome || pdLanding, 'tab') : {})
)
